import request from '@/utils/request'
import { ContentTypeJson } from '@/utils/content-type'

// 越界告警记录列表（透传，参数和响应字段一律不做改名/枚举转换，由调用方按接口原始字段处理）
export function getBoundaryAlarmList(params = {}) {
    return request({ url: '/enterprise/overrunAlarm/page', method: 'post', params })
}

// 导出越界告警（透传，与 /page 同筛选条件、不分页；响应 data 是文件下载地址字符串）
export function exportBoundaryAlarmList(params = {}) {
    return request({ url: '/enterprise/overrunAlarm/export', method: 'post', params })
}

// 越界告警筛选项与计数（透传）：告警状态/处置状态各自的数量、围栏类型全量枚举、设备名/飞手名下拉列表
export function getBoundaryAlarmFilters() {
    return request({ url: '/enterprise/overrunAlarm/filters', method: 'get' })
}

// 越界告警记录详情（透传，参数和响应字段不做改名/枚举转换）
export function getBoundaryAlarmDetail(id) {
    return request({ url: '/enterprise/overrunAlarm/detail', method: 'get', params: { id } })
}

// 处置越界告警（终态操作，不可修改；透传，参数为 { id, disposeDesc }）
export function handleBoundaryAlarm(data) {
    return request({ url: '/enterprise/overrunAlarm/dispose', method: 'post', params: data })
}

// 查询告警推送配置（透传）
export function getBoundaryAlarmConfig() {
    return request({ url: '/enterprise/overrunAlarmConfig/get', method: 'get' })
}

// 保存告警推送配置（透传）
export function saveBoundaryAlarmConfig(data) {
    return request({ url: '/enterprise/overrunAlarmConfig/save', method: 'post', ...ContentTypeJson(data) })
}
